import {Component, Input, output} from '@angular/core';
import { RdsIconComponent } from "@rds/angular-components";
import {CustomMilestone} from "../../../models/custom-milestone.model";
import {DetailedViewObjectService} from "../../../services/detailed-view-object.service";
import {ContextMenuService} from "../../../services/context-menu.service";
import {DataObject} from "../../../models/metadata";

@Component({
  selector: 'app-custom-milestone',
  standalone: true,
  imports: [
    RdsIconComponent
  ],
  templateUrl: './custom-milestone.component.html',
  styleUrl: './custom-milestone.component.scss'
})
export class CustomMilestoneComponent {
  @Input() customMilestone!: CustomMilestone
  deleteCustomMilestone = output<DataObject>()

  constructor(private detailedObjectService: DetailedViewObjectService, private contextMenuService: ContextMenuService) {
  }

  onCardClick(){
    console.log('CustomMilestone onCardClick called with:', this.customMilestone);
    this.detailedObjectService.nextDetailedObject(this.customMilestone)
  }

  onContextMenu(_: MouseEvent){
    this.contextMenuService.addItemToNextOpen('custom-milestone', () => {
      this.deleteCustomMilestone.emit(this.customMilestone as DataObject)
    })
  }

  // Contrast helper duplicated from admin tables
  getContrastColor(hexColor?: string | null): string {
    const hex = (hexColor || '').replace('#','');
    if (hex.length !== 6) {
      return '#111827';
    }
    const r = parseInt(hex.substring(0,2), 16);
    const g = parseInt(hex.substring(2,4), 16);
    const b = parseInt(hex.substring(4,6), 16);
    const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
    return luminance > 0.6 ? '#111827' : '#FFFFFF';
  }
}
